module.exports = __webpack_public_path__ + "img/ic_magazin_arrow.dac9cdac.svg";